import axios from '@/utils/request';
import { MessagePlugin } from 'tdesign-vue';

const DEFAULT_POLLING_URL = '/ent_plt_ent_manager/CommonSyncInterface';

class PollingService {
  constructor(pollingUrl = DEFAULT_POLLING_URL) {
    this.queryCount = 0;
    this.intervalTime = 1000;
    this.intervalID = null;
    this.pollingUrl = pollingUrl;
  }
  /* eslint-disable */
  startPolling(requestFn, requestParams = {}) {
    return new Promise(async (resolve, reject) => {
      this.stopPolling();

      const getKey = () => {
        return requestFn(requestParams).then(res => {
          this.intervalTime = res?.polling_interval_time;
          this.queryCount = res?.polling_count || 1;
          return res?.key;
        });
      };

      const polling = async key => {
        try {
          if (key) {
            this.queryCount -= 1;
            const res = await axios.post(this.pollingUrl, { key });
            if (res.state === 0) {
              if (this.queryCount <= 0) {
                MessagePlugin.error('请求超时，请重试');
                return Promise.reject('请求超时，请重试');
              }
              return Promise.resolve('continue');
            }

            if (res.state === 1 && res.original_code == 0) {
              return Promise.resolve(res.original_data);
            } else {
              MessagePlugin.error(res.original_msg);
              return Promise.reject({
                code: res.original_code,
                msg: res.original_msg
              });
            }
          } else {
            MessagePlugin.error('接口返回值错误');
            return Promise.reject('接口返回值错误');
          }
        } catch (err) {
          console.log(err);
          return Promise.reject(err);
        }
      };
      let error;
      const key = await getKey().catch(err => {
        error = err;
        reject(err);
      });
      if (error?.msg) return;
      const func = () => {
        polling(key)
          .then(res => {
            if (res !== 'continue') {
              resolve(res);
            } else {
              this.intervalID = setTimeout(func, this.intervalTime);
            }
          })
          .catch(err => {
            reject(err);
          });
      };
      func();
    });
  }

  stopPolling() {
    this.queryCount = 0;
    this.intervalTime = 1000;
    if (this.intervalID) {
      clearTimeout(this.intervalID);
      this.intervalID = null;
    }
  }
}

export default PollingService;
